import styled, { css } from 'styled-components';

import { getFontStyle } from '~components/Text/helper';

export const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.colors.gray800};

  & > span:not(:last-child) {
    margin-right: 5px;
  }

  &:nth-last-child(1) {
    flex-direction: column;
    gap: 8px;
  }
`;

export const SalesInfoCard = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 244px;

  ${({ theme }) => theme.media.tablet} {
    min-width: 214px;
  }

  & > hr {
    width: 30px;
    margin: 16px auto 18px;
    border-top: 1px solid ${({ theme }) => theme.colors.gray400};

    ${({ theme }) => theme.media.mobile} {
      margin: 12px auto 15px;
    }
  }

  & > ${Row}:last-child {
    margin-top: 7px;
  }

  .emphasize {
    color: ${({ theme }) => theme.colors.magenta700};
    ${getFontStyle('bold150_C1')};
  }

  .grayColor {
    color: ${({ theme }) => theme.colors.gray700};
  }
`;

export const SalesRateWrapper = styled.div`
  display: flex;
  margin-bottom: 50px;
  margin-top: 30px;

  ${({ theme }) => theme.media.tablet} {
    width: 100%;
    max-width: 640px;
    margin-left: auto;
    margin-right: auto;
    justify-content: center;
  }

  & > ${SalesInfoCard} {
    margin-top: 20px;
  }

  ${({ theme }) => theme.media.mobile} {
    flex-direction: column;
    margin-bottom: 20px;
    margin-top: 60px;

    & > ${SalesInfoCard} {
      margin-top: 0;
      margin-bottom: 30px;
    }

    & > ${SalesInfoCard}:not(:last-child) {
      margin-bottom: 60px;
    }
  }
`;

export const FinancialChartWrapper = styled.div`
  position: relative;
`;

export const ChartWrapper = styled.div`
  padding: 40px 0;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.gray400};

  ${({ theme }) => theme.media.mobile} {
    padding-left: 20px;
    padding-right: 20px;
  }
`;

export const BadgeNew = styled.div`
  padding: 3px 4px 1px;
  border-radius: 9px;
  background: ${({ theme }) => theme.colors.magenta700};
  color: ${({ theme }) => theme.colors.magenta100};
  ${getFontStyle('midium120_C1')};
`;

export const cssTitleChart = css`
  margin-bottom: 16px;
`;
